
var url_string = window.location.href;
var url = new URL(url_string);

const getMerchantId = (url) => {
    switch (url.hostname) {
        case "localhost":
            return 3408;
        case "dinein191.werafoods.com":
            return 191;    
        case "dinein1316.werafoods.com":
            return 1336;
        case "dinein1336.werafoods.com":
            return 1336;
        case "dinein1337.werafoods.com":
            return 1337;
        case "dgm.werafoods.com":
            return 1341;
        case "dinein1345.werafoods.com":
            return 1345;
        case "dinefhmulgaon.werafoods.com":
            return 577;
        case "dinein1.werafoods.com":
            return 1;   
        case "dinein2.werafoods.com":
            return 2; 
        case "dinein1357.werafoods.com":
            return 1357; 
        case "dinein630.werafoods.com":
            return 630; 
        case "dinein582.werafoods.com":
            return 582;
        case "dinein1376.werafoods.com":
            return 1376;
        case "dinein1176.werafoods.com":
            return 1176;
        case "digitalmenu3.werafoods.com":
            return 3;
        case "sammysosadinein.werafoods.com":
            return 834;            
        case "cerulean.werafoods.com":
            return 1386;
        case "dineutsav.werafoods.com":
            return 1398;
        case "dinefhambadi.werafoods.com":
            return 631;        
        case "dinefhff.werafoods.com":
            return 886;
        case "dineustadi.werafoods.com":
            return 1399;
        case "dinespesso.werafoods.com":
            return 715;
        case "dinestatus.werafoods.com":
            return 802;
        case "digitalratnagiriandheri.werafoods.com":
            return 701;
        case "digitalratnagirichembur.werafoods.com":
            return 702;
        case "dinesheetalbukhara.werafoods.com":
            return 720;
        case "dinecentralprabhu.werafoods.com":
            return 1178;
        case "dine90ftabove.werafoods.com":
            return 621;
        case "dinejeevan.werafoods.com":
            return 638;
        case "dinepersiandarbarbyculla.werafoods.com":
            return 1402;
        case "digitalkbtmalad.werafoods.com":
            return 1319;
        case "dineoyekakefort.werafoods.com":
            return 1373; 
        case "dinesadguruvegdiet686.werafoods.com":
            return 686; 
        case "dinesadguruvegdiet688.werafoods.com":
            return 688; 
        case "digitalsuveg.werafoods.com":
            return 873; 
        case "digitalkbtmasjid.werafoods.com":
            return 1111;        
        case "dineoyekakelowerparel.werafoods.com":
            return 1374;        
        case "dinevegsaagar.werafoods.com":
            return 567;
        case "dinekingchilli.werafoods.com":
            return 294;        
        case "dinetbc.werafoods.com":
            return 576;        
        case "dineblueorchidnasik.werafoods.com":
            return 1403;
        case "dinefoodstudiomulund.werafoods.com":
            return 624;
        case "digitalluckychembur.werafoods.com":
            return 610;
        case "dineglobalfusionbandra.werafoods.com":
            return 1405;
        case "digitalhotelsaibaba.werafoods.com":
            return 799;
        case "dinepooja.werafoods.com":
            return 858;        
        case "dinegazebo.werafoods.com":
            return 1414;
        case "dinecaraway.werafoods.com":
            return 1432;
        case "final.werafoods.com":
            return 191;
        case "digitalcentralcafe.werafoods.com":
            return 1417;
        case "dinecentralcafe.werafoods.com":
            return 1417;
        case "digitalmonginis.werafoods.com":
            return 1451;
        case "dineinsammysosamalad.werafoods.com":
            return 916;
        case "dinesammysosabelapur.werafoods.com":
            return 1477; 
        case "dinebrewhousecafe.werafoods.com":
            return 1487;
		case "dinehoteldhruvathare.werafoods.com":
            return 1496;
        case "dinefarmhouseborivali.werafoods.com":
            return 1502;
		case "dinesatkar.werafoods.com":
            return 1630;
		case "digitalmonginishyderabad.werafoods.com":
            return 1664;
		case "digitalmonginisdelhi.werafoods.com":
            return 1667;	
		case "dinejawahar.werafoods.com":
            return 1669;
		case "digitalmonginiskolkata.werafoods.com":
            return 1671;
		case "digitalmonginissurat.werafoods.com":
            return 1672;
		case "digitalmalvantadkabelapur.werafoods.com":
            return 1700;
        case "digitalmitron.werafoods.com":
            return 1757;
		case "dinerooftop.werafoods.com":
            return 1416;
		case "dineshivsagarandheri.werafoods.com":
            return 1720;
        case "digitalmonginisjaipur.werafoods.com":
            return 2490;
        case "rksresortkarjat.werafoods.com":
            return 3408;
        case "digitalhotelpooja.werafoods.com":
            return 4185;
        case "digitalmongicafemumbai.werafoods.com":
            return 4270;
        default:
            return 191;
    }
}

const getDigitalMenu = (url) => {
    switch (url.hostname) {
        case 'localhost':
            return false;
        case 'dgm.werafoods.com':
            return true;
        case "dinein1345.werafoods.com":
            return true;
        case "dinein2.werafoods.com":
            return true;   
        case "digitalmenu191.werafoods.com":
            return true;
        case "digitalmenu3.werafoods.com":
            return true;
        case "cerulean.werafoods.com":
            return true;
        case "digitalratnagiriandheri.werafoods.com":
            return true;
        case "digitalratnagirichembur.werafoods.com":
            return true;
        case "digitalkbtmalad.werafoods.com":
            return true;
        case "digitalsuveg.werafoods.com":
            return true;
        case "digitalkbtmasjid.werafoods.com":
            return true;
        case "digitalluckychembur.werafoods.com":
            return true;
        case "digitalhotelsaibaba.werafoods.com":
            return true;
        case "digitalcentralcafe.werafoods.com":
            return true;
        case "digitalmonginis.werafoods.com":
            return true;
		case "digitalmonginishyderabad.werafoods.com":
            return true;
		case "digitalmonginisdelhi.werafoods.com":
            return true;
		case "digitalmonginiskolkata.werafoods.com":
            return true;
		case "digitalmonginissurat.werafoods.com":
            return true;
		case "digitalmalvantadkabelapur.werafoods.com":
            return true;
        case "digitalmitron.werafoods.com":
            return true;
        case "digitalmonginisjaipur.werafoods.com":
            return true;
        case "digitalhotelpooja.werafoods.com":
            return true;
        case "digitalmongicafemumbai.werafoods.com":
            return true;
        default:
            return false;
    }
}


export const merchantId = getMerchantId(url);
export const isDigitalMenu = getDigitalMenu(url);





export const getText = (text) => {
    let data = require(`../config/${merchantId}.json`);
    return data[text];
}
export const getImage = (catId) => {
    switch (catId) {
        case 1:
            return "images/best-seller-grey.png";
            break;
        case 2:
            return "images/today-special-grey.png";
            break;
        case 3:
            return "images/chef-special-grey.png";
            break;
        case 4:
            return "images/ordered-before-grey.png";
            break;
        default:
            return "images/ordered-before-grey.png";
            break;
    }
}


export const getStatusIndex = (status) => {
    let self = {};
    if (status == "Accepted") {
        self.step = 1;
    }
    if (
        status.toLowerCase() == "pickedup" ||
        status.toLowerCase() == "picked up"
    ) {

        self.step = 2;
    }

    if (status == "Delivered") {

        self.step = 3;
    }

    if (status == "Pending") {
        self.step = 0;
    }

    if (status == "Decline") {
        self.step = -1;
    }

    if (status == "Rejected") {
        self.step = -1;
    }
    return self.step;
}


export const getTime = (expected_delivery_time) => {

    let date_now = new Date().getTime();
    let pre_time;
    let date_future = new Date(
        expected_delivery_time
    ).getTime();
    if (date_now > date_future) {
        pre_time = "Completed";
        return "Completed";
    }
    var delta = Math.abs(date_future - date_now) / 1000;
    var days = Math.floor(delta / 86400);
    delta -= days * 86400;

    // calculate (and subtract) whole hours
    var hours = Math.floor(delta / 3600) % 24;
    delta -= hours * 3600;

    // calculate (and subtract) whole minutes
    var minutes = Math.floor(delta / 60) % 60;
    delta -= minutes * 60;

    // what's left is seconds
    let seconds = Math.floor(delta % 60); // in theory the modulus is not required
    if (seconds < 10) {
        seconds = "0" + seconds;
    }
    pre_time = minutes + ":" + seconds;
    return pre_time;

}





export const subItemNames = (sub_item_content) => {

    return sub_item_content.map(addon => addon.sub_item_name).join(", ");
}

export const itemNamewithAddonV1 = (item) => {
    let item_name = item.item_name;
    if (item.size && item.size != "0") {
        item_name += " - " + item.size;
    }
    if (item.sub_item != null && item.sub_item.sub_item_content.length > 0) {
        item_name += " (" + item.sub_item.sub_item_content.map(addon => addon.sub_item_name).join(",") + ")";
    }
    return item_name;
}

export const itemNameWithAddons = (item) => {
    let item_name = item.item_name;
    if (item && item.variants.length > 0) {
        item_name += " - " + item.variants[0].variant_name;
    }
    if (item && item.addons.length > 0) {
        item_name += " (" + item.addons.map(addon => addon.name).join(",") + ")";
    }
    return item_name;
}


export const notifyMe = (title, body, click_url) => {
    if (!Notification) {
        alert('Desktop notifications not available in your browser. Try Chromium.');
        return;
    }
    //alert('here');
    if (Notification.permission !== "granted")
        Notification.requestPermission();
    else {
        var notification = new Notification(title, {
            icon: 'http://cdn.sstatic.net/stackexchange/img/logos/so/so-icon.png',
            body: body,
        });
        console.log(notification);
        notification.onclick = function () {
            window.open(click_url);
        };
        setTimeout(function () {
            notification.close();
        }, 3000);
    }
}


export const getNoPaymentMerchantIds = () => {
return [1398,621,567,886,631,582,577,858,576]
}


export const formatPrice = (price) => {
    const symbols = getCurrencySymbol();
    const decimal = getCurrencyDecimal();
    price = price.toString().replace(/[^.\d]/g, '');
    return symbols + " " + parseFloat(price).toFixed(decimal)
  }
  
  
  export const getCurrencyDecimal = () => {    
    const merchantId = getMerchantId(url);
    if (merchantId == 1417) {
      return 3;
    } 
    return 2;
  }


  export const hideVoucherCode = () => {    
    const merchantId = getMerchantId(url);
    if ([191].includes(merchantId)) {
      return false;
    } 
    return true;
  }
  
  
  export const getCurrencySymbol = () => {    
    const merchantId = getMerchantId(url);
    if (merchantId == 1417) {
      return 'BD';
    }
    if (merchantId == 1432) {
      return '£';
    }
    return '₹';
  }
  
  
  export const getCountryCode = () => {   
    const merchantId = getMerchantId(url);
    if (merchantId == 1417) {
      return 'BH';
    }
    if (merchantId == 1432) {
      return 'UK';
    }
    return 'IND';
  }
